<template>
  <div
    class="modal fade"
    id="modalConfirm"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalConfirm"
    aria-hidden="true"
    data-backdrop="static" data-keyboard="false"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">
            {{ $t("confirmation.box.title") }}
          </h3>
        </div>
        <div class="modal-body">
          <b>{{ $t(this.messageText) }}</b>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="ok()">
            {{ $t("btn.ok") }}
          </button>
          <button class="btn btn-warning" @click="cancel()">
            {{ $t("btn.cancel") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalPlugin from "@/common/plugins/ModalPlugin.js";
import $ from "jquery";

export default {
    name: "ModalConfirm",
    data() {
        return {
            OK: "ok",
            CANCEL: "cancel",
            forScreen: "",
            messageText: null
        }
    },
    mounted() {
      ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.MODAL_CONFIRM, (params, screen) => {
            this.forScreen = screen;
            $("#modalConfirm").attr("for-screen", screen);
            this.show(params);
        });
    },
    methods: {
        show(params) {
            this.messageText = params.messageText;
            $("#modalConfirm").modal("show");
        },
        hide() {
            $("#modalConfirm").modal("hide");
        },
        cancel() {
            $("#modalConfirm").modal("hide");
        },
        ok() {
            $("#modalConfirm").modal("hide");
            this.$modal.closeModalConfirm(this.OK, this.forScreen);
        }
    },
};
</script>

<style scoped>
  .modal-dialog {
    max-width: 600px;
  }
</style>
